import {CommandContainer, CommandStatus} from './type';

export default function commandsAreRunning(...commands: Array<CommandContainer<any> | null>) {
  return !!commands.find(c => c && c.status === CommandStatus.RUNNING);
}